import useAdminPermissions from 'bundles/admin-shared/hooks/useAdminPermissions';
import useDegreeLearnerMemberships from 'bundles/degree-home/components/v3-dpm/lib/useDegreeLearnerMemberships';
import useDegree from 'bundles/degree-home/utils/useDegree';

export type MembershipStatus = 'member' | 'not_member' | 'data_loading';
export type LoadedMembershipStatus = Exclude<MembershipStatus, 'data_loading'>;

/** Determine whether the current learner is part of a degree or not */
const useDegreeMembershipStatus = (degreeId?: string): MembershipStatus => {
  const { data: membershipsData, loading: membershipsLoading } = useDegreeLearnerMemberships();
  const { permissions: adminPermission, loading: adminPermissionLoading } = useAdminPermissions();
  const { data: degreeData, loading: degreeLoading } = useDegree();

  if (membershipsLoading || adminPermissionLoading || degreeLoading || !degreeId) {
    return 'data_loading';
  }

  const degreeMembership = membershipsData?.NaptimeQueries?.DegreeLearnerMembershipsV1Resource?.byUser?.elements;

  const isLearnerOfDegree = (degreeMembership ?? []).find(
    (membership) => membership?.degree?.id === degreeId && membership?.role === 'LEARNER'
  );

  const isAdminOfDegree = Boolean(adminPermission?.canViewDegreeById?.(degreeId));
  const canViewDegree = isLearnerOfDegree || isAdminOfDegree;

  if (!degreeData) {
    return 'not_member';
  }

  return canViewDegree ? 'member' : 'not_member';
};

export default useDegreeMembershipStatus;
